/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
Copyright 2022 Andrea Griffini

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

// sha256(data) returns the digest
// sha256() returns an object you can call .add(data) zero or more time and .digest() at the end
// digest is a 32-byte Uint8Array instance with an added .hex() function.
// Input should be either a string (that will be encoded as UTF-8) or an array-like object with values 0..255.
function sha256(data) {
    let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a,
        h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19,
        tsz = 0, bp = 0;
    const k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
               0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
               0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
               0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
               0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
               0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
               0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
               0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2],
          rrot = (x, n) => (x >>> n) | (x << (32-n)),
          w = new Uint32Array(64),
          buf = new Uint8Array(64),
          process = () => {
              for (let j=0,r=0; j<16; j++,r+=4) {
                  w[j] = (buf[r]<<24) | (buf[r+1]<<16) | (buf[r+2]<<8) | buf[r+3];
              }
              for (let j=16; j<64; j++) {
                  let s0 = rrot(w[j-15], 7) ^ rrot(w[j-15], 18) ^ (w[j-15] >>> 3);
                  let s1 = rrot(w[j-2], 17) ^ rrot(w[j-2], 19) ^ (w[j-2] >>> 10);
                  w[j] = (w[j-16] + s0 + w[j-7] + s1) | 0;
              }
              let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7;
              for (let j=0; j<64; j++) {
                  let S1 = rrot(e, 6) ^ rrot(e, 11) ^ rrot(e, 25),
                      ch = (e & f) ^ ((~e) & g),
                      t1 = (h + S1 + ch + k[j] + w[j]) | 0,
                      S0 = rrot(a, 2) ^ rrot(a, 13) ^ rrot(a, 22),
                      maj = (a & b) ^ (a & c) ^ (b & c),
                      t2 = (S0 + maj) | 0;
                  h = g; g = f; f = e; e = (d + t1)|0; d = c; c = b; b = a; a = (t1 + t2)|0;
              }
              h0 = (h0 + a)|0; h1 = (h1 + b)|0; h2 = (h2 + c)|0; h3 = (h3 + d)|0;
              h4 = (h4 + e)|0; h5 = (h5 + f)|0; h6 = (h6 + g)|0; h7 = (h7 + h)|0;
              bp = 0;
          },
          add = data => {
              if (typeof data === "string") {
                  data = typeof TextEncoder === "undefined" ? Buffer.from(data) : (new TextEncoder).encode(data);
              }
              for (let i=0; i<data.length; i++) {
                  buf[bp++] = data[i];
                  if (bp === 64) process();
              }
              tsz += data.length;
          },
          digest = () => {
              buf[bp++] = 0x80; if (bp == 64) process();
              if (bp + 8 > 64) {
                  while (bp < 64) buf[bp++] = 0x00;
                  process();
              }
              while (bp < 58) buf[bp++] = 0x00;
              // Max number of bytes is 35,184,372,088,831
              let L = tsz * 8;
              buf[bp++] = (L / 1099511627776.) & 255;
              buf[bp++] = (L / 4294967296.) & 255;
              buf[bp++] = L >>> 24;
              buf[bp++] = (L >>> 16) & 255;
              buf[bp++] = (L >>> 8) & 255;
              buf[bp++] = L & 255;
              process();
              let reply = new Uint8Array(32);
              reply[ 0] = h0 >>> 24; reply[ 1] = (h0 >>> 16) & 255; reply[ 2] = (h0 >>> 8) & 255; reply[ 3] = h0 & 255;
              reply[ 4] = h1 >>> 24; reply[ 5] = (h1 >>> 16) & 255; reply[ 6] = (h1 >>> 8) & 255; reply[ 7] = h1 & 255;
              reply[ 8] = h2 >>> 24; reply[ 9] = (h2 >>> 16) & 255; reply[10] = (h2 >>> 8) & 255; reply[11] = h2 & 255;
              reply[12] = h3 >>> 24; reply[13] = (h3 >>> 16) & 255; reply[14] = (h3 >>> 8) & 255; reply[15] = h3 & 255;
              reply[16] = h4 >>> 24; reply[17] = (h4 >>> 16) & 255; reply[18] = (h4 >>> 8) & 255; reply[19] = h4 & 255;
              reply[20] = h5 >>> 24; reply[21] = (h5 >>> 16) & 255; reply[22] = (h5 >>> 8) & 255; reply[23] = h5 & 255;
              reply[24] = h6 >>> 24; reply[25] = (h6 >>> 16) & 255; reply[26] = (h6 >>> 8) & 255; reply[27] = h6 & 255;
              reply[28] = h7 >>> 24; reply[29] = (h7 >>> 16) & 255; reply[30] = (h7 >>> 8) & 255; reply[31] = h7 & 255;
              reply.hex = () => {
                  let res = "";
                  reply.forEach(x => res += ("0" + x.toString(16)).slice(-2));
                  return res;
              };
              return reply;
          };
    if (data === undefined) return {add, digest};
    add(data);
    return digest();
}

// HMAC-SHA256 implementation
function hmac_sha256(key, message) {
    if (typeof key === "string") {
        key = typeof TextEncoder === "undefined" ? Buffer.from(key) : (new TextEncoder).encode(key);
    }
    if (key.length > 64) key = sha256(key);
    let inner = new Uint8Array(64).fill(0x36);
    let outer = new Uint8Array(64).fill(0x5c);
    for (let i=0; i<key.length; i++) {
        inner[i] ^= key[i];
        outer[i] ^= key[i];
    }
    let pass1 = sha256(), pass2 = sha256();
    pass1.add(inner);
    pass1.add(message);
    pass2.add(outer);
    pass2.add(pass1.digest());
    return pass2.digest();
}

//Add option for jquery "when" to receive array of ajax calls
if (typeof jQuery.when.all === 'undefined') {
  jQuery.when.all = function (deferreds) {
    return $.Deferred(function (def) {
      $.when.apply(jQuery, deferreds).then(
        // the calling function will receive an array of length N, where N is the number of
        // deferred objects passed to when.all that succeeded. each element in that array will
        // itself be an array of 3 objects, corresponding to the arguments passed to jqXHR.done:
        // ( data, textStatus, jqXHR )
        function () {
          var arrayThis, arrayArguments;

          if (Array.isArray(this)) {
            arrayThis = this;
            arrayArguments = arguments;
          }
          else {
            arrayThis = [this];
            arrayArguments = [arguments];
          }

          def.resolveWith(arrayThis, [Array.prototype.slice.call(arrayArguments)]);
        },
        // the calling function will receive an array of length N, where N is the number of
        // deferred objects passed to when.all that failed. each element in that array will
        // itself be an array of 3 objects, corresponding to the arguments passed to jqXHR.fail:
        // ( jqXHR, textStatus, errorThrown )
        function () {
          var arrayThis, arrayArguments;

          if (Array.isArray(this)) {
            arrayThis = this;
            arrayArguments = arguments;
          }
          else {
            arrayThis = [this];
            arrayArguments = [arguments];
          }

          def.rejectWith(arrayThis, [Array.prototype.slice.call(arrayArguments)]);
        });
    });
  }
}

if (typeof Dtails === "undefined") {
  var Dtails = {};
}

Dtails.AutomaticDiscount = {
  api_service: 'https://raasdal-service.herokuapp.com/discounts/auto',
  // api_service: 'https://raasdal.glitch.me/autodiscount',
  // api_service: 'https://raasdal.eu.ngrok.io/discounts/auto',
  load: function () {
    var _this = this;
    var discount_code = Cookies.get('discount_code')
    if (discount_code) {
      this.discount_code = discount_code
      //Always show banner, even with normal discount codes
      this.addBanner()

      var automatic_discount = Cookies.get('automatic_discount') ? JSON.parse(Cookies.get('automatic_discount')) : null;
      // We've already fetched the auto discount and saved as a cookie
      if (automatic_discount && automatic_discount.code == discount_code) {
        _this.setAutomaticDiscount()
        return
      }

      $.ajax({
        dataType: "json",
        url: this.api_service,
        data: { code: discount_code },
        headers: { 'x-shopify-shop-domain': window.theme.store },
        success: function (data) {
          if (data.match) {
            _this.setAutomaticDiscount(data)
          } else {
            _this.removeAutomaticDiscount()
          }
        }
      })
        .fail(function () {
          _this.removeAutomaticDiscount()
        })
    } else if (Cookies.get('automatic_discount')) {
      //Remove auto discount in case Shopifys discount code has been removed
      _this.removeAutomaticDiscount()
    }

  },
  setAutomaticDiscount: function (data) {
    if (data) {
      Cookies.set('automatic_discount', JSON.stringify(data))
    }
    this.automatic_discount = JSON.parse(Cookies.get('automatic_discount'));
    this.setCartListeners()
  },
  removeAutomaticDiscount: function () {
    Cookies.remove('automatic_discount')
  },
  addBanner: function () {
    var $banner = $('.automatic-discount-banner')
    if (window.languages.discountCodeAnnouncement) {
      $('[data-section-type="announcement-bar"]').hide()
      $banner.find('p').html(window.languages.discountCodeAnnouncement.replace('{{ code }}', this.discount_code))
      $banner.show()
    }
  },
  setCartListeners: function () {
    document.addEventListener('product:added', function (event) {
      this._checkAddedItems()
    }.bind(this));

    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail ? event.detail.cart : null
      this._checkAddedItems(cart)
    }.bind(this));

    // Set custom checkout disable. In case you change quantity line items with input field,
    // we need to disabled go to checkout until you click outside. This give time for updates to take effect
    $(document).on('focusin', '.QuantitySelector__CurrentQuantity', function (e) {
      $('.Cart__Checkout').prop('disabled', true)
    }.bind(this))

    $(document).on('focusout', '.QuantitySelector__CurrentQuantity', function (e) {
      $('.Cart__Checkout').prop('disabled', false)
    }.bind(this))
  },
  _checkAddedItems: function (cart) {
    if (cart) {
      this.checkAddedItems(cart)
    } else {
      $.getJSON(window.routes.cartUrl + '.json', function (cart) {
        this.checkAddedItems(cart)
      }.bind(this))
    }
  },
  checkAddedItems: function (cart) {
    var _this = this

    var items = []
    //Let's combine line items that may be split because of different properties. We are interested in merging the quantities
    cart.items.forEach(function (item) {
      // Don't add item if it's part of a bundle. We assume nested bundled items don't qualify for automatic discounts
      if (item.properties['_p_bundle_id']) return

      var existing = items.findIndex(function (v) { return v.variant_id == item.variant_id });
      if (existing > -1) {
        items[existing].quantity += item.quantity
      } else {
        items.push(item);
      }
    });
    var matches = items.filter(function (item) {
      return _this.automatic_discount.prerequisite_variant_ids.indexOf(item.variant_id) > -1 && item.quantity >= _this.automatic_discount.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity
    });
    var quantity_to_add = 0;
    var allocation_limit = 0;
    for (var i = 0; i < matches.length; i++) {
      var match = matches[i]
      var match_times = Math.floor(match.quantity / _this.automatic_discount.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity)

      for (var ii = 0; ii < match_times; ii++) {
        if (allocation_limit < _this.automatic_discount.allocation_limit) {
          quantity_to_add += _this.automatic_discount.prerequisite_to_entitlement_quantity_ratio.entitled_quantity
          // For every match, we allocate one usage
          allocation_limit += 1;
        }
      }
    }
    var entitled_variant_id = _this.automatic_discount.entitled_variant_ids[0] // For now let's just assume there is only one variant to add for free
    var entitled_item = items.find(function (i) { return i.variant_id == entitled_variant_id && i.properties['_automatic_discount'] })

    if (entitled_item && entitled_item.quantity == quantity_to_add) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      return // No changes needed
    }

    if (entitled_item) {
      var url = window.routes.cartChangeUrl + '.js'
      var body = { id: entitled_item.key, quantity: quantity_to_add, properties: { _automatic_discount: _this.automatic_discount.code } }
    } else {
      var url = window.routes.cartAddUrl + '.js'
      var body = { items: [{ id: entitled_variant_id, quantity: quantity_to_add, properties: { _automatic_discount: _this.automatic_discount.code } }] }
    }
    fetch(url, {
      body: JSON.stringify(body),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      // Add slight delay. Unfortunately we have to as there are animations on the cart drawer
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 500)
    });
  }
}

Dtails.cartEnableTerms = function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest('button[name="checkout"]')) return;
    document.querySelector('.Form__CheckboxError').style.display = 'none';
    var termsCheckbox = document.getElementById('CartTerms')
    if (termsCheckbox.checked) {
      return true;
    } else {
      e.preventDefault();
      document.querySelector('.Form__CheckboxError').style.display = 'block';
    }
  }, false);
}

function roundDiscount(rawDiscountedPrice) {
  // Format to "nice" prices ending in .09 (.09, .19, .29, etc.)
  let wholePart = Math.floor(rawDiscountedPrice);
  let decimalPart = rawDiscountedPrice - wholePart;
  //console.log('wholePart', wholePart);
  //console.log('decimalPart', decimalPart);
  
  // Always round DOWN to nearest .09 increment
  if (decimalPart < 0.09) {
    // Less than 0.09 goes to previous whole number + 0.99
    discounted_price = wholePart - 0.01;
  } else if (decimalPart < 0.19) {
    discounted_price = wholePart + 0.09;
  } else if (decimalPart < 0.29) {
    discounted_price = wholePart + 0.19;
  } else if (decimalPart < 0.39) {
    discounted_price = wholePart + 0.29;
  } else if (decimalPart < 0.49) {
    discounted_price = wholePart + 0.39;
  } else if (decimalPart < 0.59) {
    discounted_price = wholePart + 0.49;
  } else if (decimalPart < 0.69) {
    discounted_price = wholePart + 0.59;
  } else if (decimalPart < 0.79) {
    discounted_price = wholePart + 0.69;
  } else if (decimalPart < 0.89) {
    discounted_price = wholePart + 0.79;
  } else if (decimalPart < 0.99) {
    discounted_price = wholePart + 0.89;
  } else {
    // Exactly 0.99 or higher (shouldn't happen due to precision) becomes next whole number minus 0.01
    discounted_price = wholePart + 0.99;
  }
  
  console.log('discounted_price', discounted_price);
  
  // Special case for exact whole numbers
  if (decimalPart === 0) {
    discounted_price = wholePart - 0.01; // Previous whole number + 0.99
  }

  return discounted_price;
}

Dtails.CrossSellModal = {
  init: function () {

    this.page_has_cross_sell = true

    if (!window.crossSellConfigs) {
      this.unbindCrossSell()
      return
    }

    this.$crossSellModal = $('[data-cross-sell-modal]')
    this.$crossSellModalContent = $('[data-cross-sell-content]', this.$crossSellModal)

    this.product_forms = {}
    this.products = []

    $(document).on('product:added', this.setupSources.bind(this))

    $('[data-action="close-modal"]', this.$crossSellModal).on('click', this.closeModal.bind(this));

  },
  setupSources: function (e) {
    this.product_id = e.detail.product_id
    this.variant_id = e.detail.variant.id
    this.line_item_key = e.detail.items.find(function (item) { return item.variant_id == e.detail.variant.id }).key
    if (!this.product_id || !window.crossSellConfigs[this.product_id] || !window.crossSellConfigs[this.product_id].length) {
      this.unbindCrossSell()
      return
    }
    this.page_has_cross_sell = true

    // let products = window.crossSellConfigs[this.product_id].flatMap(config => config.products)
    // products = products.filter((item, pos) => products.findIndex(i => i.id == item.id) == pos)
    // this.products = products

    // new
    var sources = window.crossSellConfigs[this.product_id]
    this.products = this.sortProducts(sources)

    if (this.products.length) {
      this.prerenderProducts()
    } else {
      this.unbindCrossSell()
    }
  },
  sortProducts: function (sources) {
    var items = []
    //console.log('sources', sources)
    for (var i = 0; i < sources.length; i++) {
      var source = sources[i]

      for (var ii = 0; ii < source.products.length; ii++) {
        var product = source.products[ii]
        if (!product.id) {
          continue
        }
        for (var iii = 0; iii < product.variants.length; iii++) {
          var variant = source.products[ii].variants[iii]
          var discounted_price = variant.price;
          if (source.discount_percent > 0) {
            // Calculate the exact discounted price
            let rawDiscountedPrice = parseFloat(variant.price) * (1 - (source.discount_percent / 100));
            
            if (window.theme.roundedDiscount) {
              // Round down to whole number if roundedDiscount is true
              discounted_price = Math.floor(rawDiscountedPrice);
            } else {
              roundDiscount(rawDiscountedPrice);
            }
          }
          
          var price = parseFloat(variant.price)
          var discount_percentage = ((price - discounted_price) / price) * 100 //Calcuate percentage based on the actual savings and round down
          var discount_percentage_rounded = Math.floor(discount_percentage) //Calcuate percentage based on the actual savings and round down
          items.push({
            variant_id: variant.id,
            product_id: product.id,
            quantity: product.quantity || 1,
            source: source,
            price,
            original_variant_price: variant.original_variant_price,
            compare_at_price: parseFloat(variant.compare_at_price),
            is_bundle: variant.is_bundle,
            discounted_price: discounted_price.toFixed(2),
            discount_percentage,
            discount_percentage_rounded,
            parent_variant_id: this.variant_id,
            parent_line_item_key: this.line_item_key
          })
        }
      }
    }

    items = items.filter((item, pos) => items.findIndex(i => i.variant_id == item.variant_id) == pos)

    return items.sort(function (a, b) { return a.discounted_price - b.discounted_price })
  },
  unbindCrossSell: function () {
    this.page_has_cross_sell = false
    this.loading = false
    document.documentElement.dispatchEvent(new CustomEvent('cross-sell:closed', {
      bubbles: true
    }));
  },
  prerenderProducts: function () {
    var self = this
    var queryString = this.getSearchQueryString(this.products)

    $.get(window.routes.searchUrl + '?view=product-cross-sell&type=product&q=' + queryString, function (response) {
      var objResponse = Object.values(response);
      if (objResponse && objResponse.length) {
        this.shopify_cross_sell_products_html = response
        let products_html = this.renderProducts()

        if (products_html.length) {
          this.$crossSellModalContent.html(products_html.join(''));
          this.initModalForms()
          this.openModal()
          document.querySelectorAll('#modal-rebuy .ProductItem').forEach(function (item) {
            // handle bundle product in upsell
            if (item.querySelector('[data-bundle-json]')) {
              let pBundleData = JSON.parse(item.querySelector('[data-bundle-json]')?.innerHTML);
              let parentVariantId = item.querySelector('[data-bundle-json]')?.getAttribute('data-parent-variant-id');
              if (typeof window.crossSellBundleData == 'undefined') {
                window.crossSellBundleData = {};
              }
              window.crossSellBundleData[parentVariantId] = pBundleData;
              // console.log(window.crossSellBundleData);
              self.bundleBackinstockDisplay(pBundleData, item);
            }
          })
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cross-sell:closed', {
            bubbles: true
          }));
        }
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cross-sell:closed', {
          bubbles: true
        }));
      }
      this.loading = false
    }.bind(this), 'json')

  },
  bundleBackinstockDisplay: function(bundleData, container) {
    var _this = this;
    var stockStatusArr = [];
    var finalPreorderText = '';
    var finalPreorderDate = '';
    var isSoldOut = false;
    var isAllSoldOutHasAvailPreorderDate = true;

    // If all childs are is_prepacked, follow parent stock
    var isAllChildsPrepacked = true;
    bundleData.forEach(function(b) {
      if (b.is_prepacked == false) {
        isAllChildsPrepacked = false;
      }
    });

    if (!isAllChildsPrepacked) {
      bundleData.forEach(function(b) {
        //Select first variant as default
        var bundleVariant = b.variants[0]
        var bundleVariantSelect = $('[data-bundle-product-id="' + b.product_id + '"] :first select[data-bundle-variant] :selected')
        if (bundleVariantSelect.length) {
          bundleVariant = b.variants.find(function(v){ return v.id == bundleVariantSelect.val() }) || bundleVariant
        }

        if (finalPreorderText == '') {
          finalPreorderText = bundleVariant.stock_backinstock_text;
          finalPreorderDate = bundleVariant.stock_backinstock_date_ymd;
        } else {
          let finalPreorderDateTime = new Date(finalPreorderDate);
          let bundlePreOrderDate = new Date(bundleVariant.stock_backinstock_date_ymd);
          if (bundlePreOrderDate.getTime() > finalPreorderDateTime.getTime()) {
            finalPreorderText = bundleVariant.stock_backinstock_text;
            finalPreorderDate = bundleVariant.stock_backinstock_date_ymd;
          }
        }
        if (bundleVariant.stock_text_type == 'soldout') {
          isSoldOut = true;
          if (bundleVariant.stock_backinstock_text == '') {
            isAllSoldOutHasAvailPreorderDate = false;
          }
        } else {
          stockStatusArr.push(bundleVariant.stock_text_type)
        }
      })
    }

    let stockStatusTextArr = container.querySelectorAll('[stock-status-text]');
    if (isSoldOut) {
      container.classList.add('soldout');
      // update soldout text and button
      if (stockStatusArr.indexOf('preorder_with_passed_date') >= 0 || stockStatusArr.indexOf('preorder_with_unknown_date') >= 0 || !isAllSoldOutHasAvailPreorderDate) {
        _this._updateStockText(stockStatusTextArr, 'soldout', '');
      } else {
        _this._updateStockText(stockStatusTextArr, 'soldout', finalPreorderText);
      }
    } else {
      if (stockStatusArr.indexOf('preorder_with_passed_date') >= 0 || stockStatusArr.indexOf('preorder_with_unknown_date') >= 0) {
        // update preorder unknown date or passed date text and button, same function
        _this._updateStockText(stockStatusTextArr, 'preorder_with_passed_date', '');
      } else if (stockStatusArr.indexOf('preorder_with_available_date') >= 0) {
        // update preorder text and button
        _this._updateStockText(stockStatusTextArr, 'preorder_with_available_date', finalPreorderText);
      } else if (stockStatusArr.indexOf('preorder_remote_stock') >= 0) {
        // update remote text and button
        _this._updateStockText(stockStatusTextArr, 'preorder_remote_stock', '');
      } else {
        // update instock text and button
        _this._updateStockText(stockStatusTextArr, 'instock', '');
      }
    }
  },
  _updateStockText: function(stockStatusTextArr, type, customText) {
    // We show the correct stock message based on stock
    stockStatusTextArr.forEach((stockStatus) => {
      if (stockStatus.getAttribute('data-stock-type') == type) {
        stockStatus.classList.remove('hidden');
        if (customText != '') {
          if (type == 'preorder_with_available_date' || type == 'soldout') {
            stockStatus.querySelector('span').innerText = customText;
          }
        }
      } else {
        stockStatus.classList.add('hidden');
      }
    });
  },
  renderProducts: function () {
    let self = this;
    // Use original rebuy data to get sort order
    if (typeof this.products == 'undefined') {
      this.products = [];
    }
    var products_html = this.products.map(function (p) {
      if (!this.shopify_cross_sell_products_html) {
        return ''
      }
      var html = this.shopify_cross_sell_products_html[p.variant_id];
      if (!html) {
        return ''
      }

      // var discount_price = p.source.discount_percent == 100 ? theme.Currency.formatMoney(0, theme.moneyFormat) : theme.Currency.formatMoney(Math.floor(parseInt(p.discounted_price)) * 100, theme.moneyFormat)
      var discount_price = theme.Currency.formatMoney(Math.floor(parseInt(p.discounted_price)) * 100, theme.moneyFormat)
      if (p.source.discount_percent == 100) {
        discount_price = theme.Currency.formatMoney(0, theme.moneyFormat)
      } else if (window.theme.roundedDiscount != true) {
        discount_price = theme.Currency.formatMoney(p.discounted_price, theme.moneyFormat)
      }

      let discountPercentRounded = p.discount_percentage_rounded;

      if (p.source.discount_percent == 0 && p.is_bundle) {
        // need to calc the compare price for bundle the same way as showing on pdp
        discount_price = window.theme.roundedDiscount ? theme.Currency.formatMoney(Math.floor(parseFloat(p.original_variant_price)) * 100, theme.moneyFormat) : theme.Currency.formatMoney(p.original_variant_price, theme.moneyFormat)
        if (p.original_variant_price && p.compare_at_price > p.original_variant_price) {
          discountPercentRounded = Math.floor(((p.price - p.original_variant_price) / p.price) * 100);
        } else {
          html = html.replace(/{{ discount_wrapper_class }}/g, 'hidden')
        }
      } else {
        if (p.compare_at_price > p.discounted_price) {
          // calculate new discount percent
          discountPercentRounded = Math.floor(((parseFloat(p.price) - parseFloat(p.discounted_price)) / parseFloat(p.price)) * 100);
        } else {
          html = html.replace(/{{ discount_wrapper_class }}/g, 'hidden')
        }
      }

      let compare_at_price = window.theme.roundedDiscount ? theme.Currency.formatMoney(Math.floor(parseFloat(p.price)) * 100, theme.moneyFormat) : theme.Currency.formatMoney(p.price * 100, theme.moneyFormat)

      const hash_input = "gid://shopify/ProductVariant/" + p.variant_id + "," + p.discount_percentage_rounded;
      html = html.replace(/{{ price }}/g, discount_price);
      html = html.replace(/{{ compare_at_price }}/g, compare_at_price)
      html = html.replace(/{{ discount_display }}/g, discountPercentRounded)
      html = html.replace(/{{ discount }}/g, p.discount_percentage_rounded)
      html = html.replace(/{{ discount_h }}/g, sha256(hash_input).hex())
      html = html.replace(/{{ _variant_id_parent }}/g, p.parent_variant_id)
      html = html.replace(/{{ _discount_parent }}/g, p.parent_line_item_key)
      return html
    }.bind(this));

    return products_html
  },
  getSearchQueryString: function (items) {
    items = items.filter(function(item) {
      return item && item.product_id !== null
    })
    return items.map(function (item) {
      return 'id:' + item.product_id;
    }).join(' OR ');
  },
  initModalForms: function () {
    var _this = this
    this.$crossSellModalContent.find('[data-rebuy-item] [data-action="add-to-cart"]').attr('disabled', true)
    this.$crossSellModalContent.find('[data-rebuy-item]').each(function () {
      var $this = $(this)
      var id = $this.data('rebuy-item')
      var productVariants = new window.theme.ProductVariants($(this)[0], { useAjaxCart: true, contain_events: true, showPriceInButton: false, preferredSelectorPosition: 'top' });
      _this.product_forms[id] = {
        productVariants: productVariants
      }
      $this.find('[data-action="add-to-cart"]').attr('disabled', false)
      $this.on('product:added', function () {
        $this.find('button.ProductForm__AddToCart').addClass('ProductForm__AddToCart--added')
      }.bind(this))
      $this.on('variant:changed', function (event) {
      }.bind(this))
    })
  },
  openModal: function () {
    var _this = this
    this.pageOverlayElement = document.querySelector('.PageOverlay');
    modal = this.$crossSellModal[0]

    this.activeModal = modal;

    if (document.documentElement.classList.contains('no-scroll')) {
      this.wasLocked = true;
    }

    this.activeModal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');

    this.pageOverlayElement.classList.add('is-visible');
  },
  closeModal: function () {
    // this.pageOverlayElement.classList.remove('is-visible');

    this.activeModal.setAttribute('aria-hidden', 'true');
    this.activeModal = null;
    this.page_has_cross_sell = false;

    document.documentElement.dispatchEvent(new CustomEvent('cross-sell:closed', {
      bubbles: true
    }));

    if (!this.wasLocked) {
      document.documentElement.classList.remove('no-scroll');
    }
  },
  isActive: function () {
    return this.page_has_cross_sell
  }
}

Dtails.productCartAjax = function (parentSelector = 'body') {
  //Fetch products based on handles with search
  var bundleHandleArr = [];
  $(`${parentSelector} [data-product-item-form] [data-collection-bundle-json]`).each(function () {
    let jsonBundle = JSON.parse($(this).html().trim());
    for (bundle of jsonBundle) {
      if (bundleHandleArr.indexOf(bundle.handle) < 0) {
        bundleHandleArr.push(bundle.handle);
      }
    }
  });
  bundleHandleArr = bundleHandleArr.filter(function (item) {
    return item && item.trim() !== '';
  });
  if (bundleHandleArr.length) {
    var queryString = bundleHandleArr.map(function (handle) {
      return 'handle:' + handle;
    }).join(' OR ');
    $.get(window.routes.searchUrl + '?view=bundle&type=product&q=' + queryString, function (response) {
      let arrBundleFromSearch = JSON.parse(response);
      $(`${parentSelector} [data-product-item-form] [data-collection-bundle-json]`).each(function () {
        let jsonBundle = JSON.parse($(this).html().trim());
        let bundleArrFinal = [];

        for (bundle of jsonBundle) {
          let isMatched = false;
          for (item of arrBundleFromSearch) {
            if (item.bundle_handle.toLowerCase() == bundle.handle.toLowerCase()) {
              bundle.product_id = item.product_id;
              bundle.title = bundle.quantity + ' x ' + item.title;
              bundle.variants = [];
              bundle.default_variant = bundle.default_variant ? bundle.default_variant : item.active_variant_id;

              // sort first selected or available variant to be first element in array
              for (variant of item.variants) {
                if (variant.id == item.active_variant_id) {
                  bundle.variants.push(variant);
                }
              }
              for (variant of item.variants) {
                if (variant.id != item.active_variant_id) {
                  bundle.variants.push(variant);
                }
              }

              bundleArrFinal.push(bundle);
              isMatched = true;
            }
          }
          if (!isMatched) {
            bundle.product_id = '';
            bundle.title = '';
            bundle.variants = [
              {
                "id": "",
                "title": "",
                "stock_text_type": "soldout",
                "stock_backinstock_date_ymd": "1970-01-01",
                "stock_backinstock_date": "01-01-70",
                "stock_backinstock_text": ""
              }
            ]
            bundleArrFinal.push(bundle);
          }
        }
        $(this).closest('[data-product-item-form]').find('[product-bundle-json-blank]').text(JSON.stringify(bundleArrFinal));
        $(this).closest('[data-product-item-form]').find('[product-bundle-json-blank]').attr('data-bundle-json', '');
      });

      //Add ATC/form functionality to all product items on collection pages
      $(`${parentSelector} [data-product-item-form]`).each(function () {
        var $this = $(this)
        var productVariants = new window.theme.ProductVariants($(this)[0], { useAjaxCart: true });
        // $this.on('product:added', function(){
        //   $this.find('button.ProductForm__AddToCart').addClass('ProductForm__AddToCart--added')
        // }.bind(this))
      })

    }.bind(this));
  } else {
    //Add ATC/form functionality to all product items on collection pages
    $(`${parentSelector} [data-product-item-form]`).each(function () {
      var $this = $(this)
      var productVariants = new window.theme.ProductVariants($(this)[0], { useAjaxCart: true });
      // $this.on('product:added', function(){
      //   $this.find('button.ProductForm__AddToCart').addClass('ProductForm__AddToCart--added')
      // }.bind(this))
    })
  }
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

Dtails.DiscountUpsell = {
  total_price: 0,
  total_discount: 0,
  totalGiftDiscountedPrice: 0,
  initGlobalEventHandlers: function () {
    document.addEventListener('cart:updated', debounce(this._onCartUpdated.bind(this), 200));
  },
  init: function () {

    this.loading(true)
    this.$container = $('[data-product-upsell]')

    this.product_id = this.$container.data('product-upsell')

    if (!window.upsellConfigs[this.product_id]) {
      this.loading(false)
      return
    }

    this.discount_sources = []
    this.gift_sources = []

    this.$containergift = $('[data-rebuy-gift-product]')

    this.content = document.querySelector('[data-product-upsell] .discount-upsell__list')
    this.showSaveUpToLabel = this.$container.data('show-save-upto-label')
    this.content.style.display = "block"

    this.showMoreButtons = document.querySelectorAll('.discount-upsell__showmore')

    this.showMoreButtons.forEach((button) => {
      button.addEventListener("click", this.showMore.bind(this))
    })

    addEventListener('resize', debounce(this.resizeGiftProduct.bind(this), 300));

    document.addEventListener('product:added', this._onProductAdded.bind(this))

    this.setupSources()

  },

  setupSources: function(){
    var sources = window.upsellConfigs[this.product_id]

    this.gift_sources = sources.filter(source => source.discount_percent == 100)
    this.discount_sources = sources.filter(source => source.discount_percent != 100 && !this.gift_sources.some(gift => gift.products.some(giftProduct => source.products.some(product => product.id == giftProduct.id))))
    this.products = this.sortProducts(this.discount_sources)
    this.giftProducts = this.sortProducts(this.gift_sources)
    // console.log('origin', this.giftProducts)
    
    if (window.fallback_gifts && window.fallback_gifts[this.product_id]) {
      const fallbackVariants = window.fallback_gifts[this.product_id] || [];
      if (fallbackVariants.length) {
        // console.log(fallbackVariants)
        // console.log(' gift products', this.giftProducts)
        const fallbackThreshold = fallbackVariants[0].inventory_threshold || 0;
        // find a replacement for unavailable gifts
        const usedReplacements = new Set();
        this.giftProducts = this.giftProducts.map(gift => {
          let shouldReplace = false;
          if (!gift.variant_available) {
            shouldReplace = true;
          } else {
            if (gift.inventory_policy == 'continue' || !gift.inventory_management) {
              // not track inventory or continue selling when out of stock
              shouldReplace == false
            } else {
              // track qty
              if (gift.inventory_quantity <= fallbackThreshold) {
                shouldReplace = true;
              }
            }
          }
          let replacementGift = null;
          if (shouldReplace) {
            for (const fallback of fallbackVariants) {
              // const fallbackThreshold = fallback.inventory_threshold || 0;
              const replacement = fallback.variants.find(v => v.variant_available && !usedReplacements.has(v.variant_id));
              if (replacement) {
                usedReplacements.add(replacement.variant_id); // Mark as used
                replacementGift = replacement; // Replace with the first available unique variant
                break;
              }
            }
          }
          if (replacementGift) {
            return replacementGift;
          }
          return gift;
        });
      }
    }
    // console.log('new', this.giftProducts)

    if (this.products.length) {
      this.prerenderProducts()
    } else {
      this.loading(false)
    }
    // filter gift products that have variant_available false. clickup #869a73fdz
    this.giftProducts = this.giftProducts.filter(function (gift) {
      return gift.variant_available;
    });
    if (this.giftProducts.length) {
      this.prerenderProducts('gift')
    }

  },

  showMore: function (e) {
    var button = e.target
    if (button.classList.contains("show-more")) {
      button.classList.remove("show-more");
      button.innerHTML = button.getAttribute("data-show-less");
      document.querySelectorAll(".discount-upsell__list li").forEach((input) => {
        input.style.display = "flex";
      });
    } else {
      button.classList.add("show-more");
      button.innerHTML = button.getAttribute("data-show-more");
      this.$container.each(function () {
        $(this).find('.discount-upsell__list li').each(function (idx) {
          if (idx > 3) {
            $(this).hide()
          }
        })
        if ($(this).is(':visible')) {
          $('html, body').animate({
            scrollTop: $(this).offset().top - 50
          });
        }
      })
    }
  },
  resizeGiftProduct: function () {

    if (window.innerWidth < 1008) {
      let k = document.querySelector(".rebuy-gift-product-lap-and-up").innerHTML;

      if (k != null) {
        document.querySelector(".rebuy-gift-product-mobile").innerHTML = k;
        document.querySelector(".rebuy-gift-product-lap-and-up").length = 0;
      }
    }
  },
  loading: function (loading) {
    if (loading) {
      $('[data-action="add-to-cart"]').attr('disabled', 'disabled')
    } else {
      $('[data-action="add-to-cart"]').attr('disabled', null)
    }
  },
  collectionInit: function () {
    if (!window.upsellConfigs) {
      return
    }

    $('[data-action="add-to-cart"]').attr('disabled', null)

    document.addEventListener('product:added', this._onCollectionProductAdded.bind(this));
  },
  _onCollectionProductAdded: function (event) {
    var product_id = event.detail.product_id
    if (!product_id) return

    var _this = this

    // gift product collection add auto
    let gift_sources = window.upsellConfigs[product_id] || []
    gift_sources = gift_sources.filter(function (source) { return source.discount_percent == 100 })

    fetch(window.routes.cartUrl + '.js').then(function (cart) {
      return cart.json();
    }).then(function (data) {
      const found_parent_variant = new Set()
      // update gift free product
      if (data.items.length) {
        var to_be_updated = {}
        for (var i = 0; i < data.items.length; i++) {
          let item = data.items[i]
          if (item.properties._variant_id_parent && item.properties._type_free_product) {
            let found_parent = data.items.find(function (it) {
              return it.variant_id == item.properties._variant_id_parent && it.properties._AddedFrom == item.properties._AddedFrom
            })

            let found_parent_bundle = data.items.filter(function (it, index) {
              if (it.variant_id == item.properties._variant_id_parent && it.properties._AddedFrom == item.properties._AddedFrom && it.properties._bundle_id) {
                return it;
              }
            })

            let is_bundle = item.properties._bundle_id ? true : false

            if (found_parent && !is_bundle) {
              found_parent_variant.add(found_parent.variant_id)
              // add check update or add cart
              if (found_parent_bundle && found_parent_bundle.length) {
                to_be_updated[item.key] = found_parent_bundle.length
              } else {
                // 100% discount only. Let's try to figure out how many there should be
                if (item.properties._du == 100 && (found_parent.quantity * item.properties._discount_quantity) != item.quantity) {
                  // Quantity doesn't match, let's add it to update
                  to_be_updated[item.key] = found_parent.quantity * item.properties._discount_quantity
                }
              }
            }
          }
        }
        if (Object.keys(to_be_updated).length > 0) {
          console.log(to_be_updated)
          var url = window.routes.cartUpdateUrl + '.js'
          var body = { updates: to_be_updated }
          fetch(url, {
            body: JSON.stringify(body),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (cart) {
            return cart
          }).then(function () {
            setTimeout(function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }, 500)
          });
        }
      }
      return found_parent_variant;
    }).then(function (dataParent) { // type: set
      let item_added = event.detail.items ? event.detail.items[0] : null
      let items = []
      if (item_added.properties._AddedFrom && item_added.properties._AddedFrom == 'cart-cross-sell') {
        // preventing add gift product & related product when adding a product from another areas eg cart cross-sell.. but inside main product page
        return;
      }
      if (item_added && !dataParent.has(item_added.variant_id)) {
        let discount_id = '1'
        if (item_added.properties._bundle_id) {
          discount_id = item_added.key
        }
        let variant_id_parent = item_added.variant_id
        let gift_sources_variant = _this.sortProducts(gift_sources)
        if (window.fallback_gifts && window.fallback_gifts[this.product_id]) {
          const fallbackVariants = window.fallback_gifts[this.product_id] || [];
          if (fallbackVariants.length) {
            const fallbackThreshold = fallbackVariants[0].inventory_threshold || 0;
            // find a replacement for unavailable gifts
            const usedReplacements = new Set();
            gift_sources_variant = gift_sources_variant.map(gift => {
              let shouldReplace = false;
              if (!gift.variant_available) {
                shouldReplace = true;
              } else {
                if (gift.inventory_policy == 'continue' || !gift.inventory_management) {
                  // not track inventory or continue selling when out of stock
                  shouldReplace == false
                } else {
                  // track qty
                  if (gift.inventory_quantity <= fallbackThreshold) {
                    shouldReplace = true;
                  }
                }
              }
              let replacementGift = null;
              if (shouldReplace) {
                for (const fallback of fallbackVariants) {
                  // const fallbackThreshold = fallback.inventory_threshold || 0;
                  const replacement = fallback.variants.find(v => v.variant_available && !usedReplacements.has(v.variant_id));
                  if (replacement) {
                    usedReplacements.add(replacement.variant_id); // Mark as used
                    replacementGift = replacement; // Replace with the first available unique variant
                    break;
                  }
                }
              }
              if (replacementGift) {
                return replacementGift;
              }
              return gift;
            });
          }
        }
        // remove any gift that have variant_available false
        gift_sources_variant = gift_sources_variant.filter(function (gift) {
          return gift.variant_available;
        });
        gift_sources_variant.forEach(function (variant) {
          const discount_percentage = 100
          const hash = sha256("gid://shopify/ProductVariant/" + variant.variant_id + "," + discount_percentage).hex()
          let item = {
            id: variant.variant_id,
            quantity: variant.quantity,
            properties: {
              _du: discount_percentage,
              _dh: hash,
              _discount_parent: discount_id,
              _discount_quantity: variant.quantity,
              _variant_id_parent: variant_id_parent,
              _type_free_product: 'free gift',
              _AddedFrom: item_added.properties._AddedFrom
            }
          };

          // Add additional bundles to cart
          item = _this.addBundleData(item, variant.product_id);

          items.push(item)
        })

        let combined_items = items.reduce(function (acc, item) {
          let index = acc.findIndex(function (i) { return i.id === item.id })
          if (index > -1) {
            acc[index].quantity += 1
            acc[index].properties._discount_quantity += 1
          } else {
            item.quantity = item.quantity
            acc.push(item)
          }
          return acc
        }, [])

        if (combined_items.length > 0) {
          fetch(window.routes.cartAddUrl + '.js', {
            body: JSON.stringify({ items: combined_items }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (cart) {
            // Add slight delay. Unfortunately we have to as there are animations on the cart drawer
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          });
        }
      }

    })

  },
  _onCartUpdated: function (event) {
    // console.log(1)
    that = this
    //Let's remove any possible discount upsell items if the parent product is no longer in the cart
    var cart = event.detail.cart
    let payload = event.detail.payload
    let requiresUpdate = false
    // console.log(event.detail)
    if (cart) {
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      if (document.querySelector('.template-cart .Cart__Footer button.Cart__Checkout')) {
        document.querySelector('.template-cart .Cart__Footer button.Cart__Checkout').setAttribute('disabled', 'disabled');
      }
      var to_be_updated = []
      for (var i = 0; i < cart.items.length; i++) {
        let item = cart.items[i]
        // console.log('item', item)
        if (item.properties && item.properties._discount_parent) {
          if (payload.updates) {
            // console.log('payload.updates', payload.updates)
            // product just updated is bundle parent
            let found_parent = cart.items.find(function (it) {
              let isAddedFromMatched = it.properties._AddedFrom == item.properties._AddedFrom || (it.properties._AddedFrom == 'product-template' && (item.properties._AddedFrom == 'upsell-gift' || item.properties._AddedFrom == 'upsell' || item.properties._AddedFrom == 'cart-cross-sell')) || ((it.properties._AddedFrom == 'cart-cross-sell' || it.properties._AddedFrom == 'collection') && item.properties._AddedFrom == 'cart-cross-sell');
              return it.variant_id == item.properties._variant_id_parent && it.key == item.properties._discount_parent && isAddedFromMatched;
            });
            if (found_parent) {
              if (item.properties._type_free_product == 'free gift') {
                to_be_updated.push({ id: item.key, quantity: found_parent.quantity * item.properties._discount_quantity })
              }
            } else {
              to_be_updated.push({ id: item.key, quantity: 0 })
            }
          } else {
            let found_parent = cart.items.find(function (it) {
              if (item.properties._parent_product_has_bundle_gift_id) {
                return it.variant_id == item.properties._variant_id_parent && !it.properties._p_bundle_id && it.properties._product_has_bundle_gift_id == item.properties._parent_product_has_bundle_gift_id
              } else {
                let isAddedFromMatched = it.properties._AddedFrom == item.properties._AddedFrom || (it.properties._AddedFrom == 'product-template' && (item.properties._AddedFrom == 'upsell-gift' || item.properties._AddedFrom == 'upsell' || item.properties._AddedFrom == 'cart-cross-sell')) || ((it.properties._AddedFrom == 'cart-cross-sell' || it.properties._AddedFrom == 'collection') && item.properties._AddedFrom == 'cart-cross-sell');
                return it.variant_id == item.properties._variant_id_parent && !it.properties._p_bundle_id && isAddedFromMatched
              }
            });
            // console.log('found_parent', found_parent)
            if (found_parent) {
              if (item.properties._type_free_product == 'free gift') {
                to_be_updated.push({ id: item.key, quantity: found_parent.quantity * item.properties._discount_quantity })
              }
            } else {
              to_be_updated.push({ id: item.key, quantity: 0 })
              if (item.properties._bundle_id) {
                // is bundle product. also remove all child product of it
                let found_bundle = cart.items.filter(function (it) {
                  return it.properties._p_bundle_id == item.properties._bundle_id
                });
                found_bundle.forEach(function (child) {
                  to_be_updated.push({ id: child.key, quantity: 0 })
                })
              }
            }
          }
        }
      }

      function changeItem() {
        var body = to_be_updated.shift()
        fetch(window.routes.cartChangeUrl + '.js', {
          body: JSON.stringify(body),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {          
          return response.json()
        }).then(function (cart) {
          if (to_be_updated.length) {
            changeItem()
          } else {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              if (document.querySelector('.template-cart .Cart__Footer button.Cart__Checkout')) {
                document.querySelector('.template-cart .Cart__Footer button.Cart__Checkout').removeAttribute('disabled');
              }
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }, 300)
          }
        })
      }
      if (to_be_updated.length) {
        changeItem()
      } else {
        if (document.querySelector('.template-cart .Cart__Footer button.Cart__Checkout')) {
          document.querySelector('.template-cart .Cart__Footer button.Cart__Checkout').removeAttribute('disabled');
        }
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    }
  },

  _onProductAdded: function (event) {
    const item_added = event.detail.items ? event.detail.items[0] : null;
    const _this = this;
    if (item_added) {
      fetch(window.routes.cartUrl + '.js').then(function (cart) {
        return cart.json();
      }).then(function (data) {
        const found_parent_variant = new Set()
        // update gift free product
        if (data.items.length) {
          var to_be_updated = {}
          for (let i = 0; i < data.items.length; i++) {
            let item = data.items[i]
            if (item.properties) {
              if (item.properties._variant_id_parent) {
                let found_parent_bundle = data.items.filter(function (it, index) {
                  let isAddedFromMatched = it.properties._AddedFrom == item.properties._AddedFrom || (it.properties._AddedFrom == 'product-template' && item.properties._AddedFrom == 'upsell-gift');
                  if (it.variant_id == item.properties._variant_id_parent && it.properties._bundle_id && isAddedFromMatched) {
                    return it;
                  }
                })

                let found_parent = data.items.find(function (it, index) {
                  if (it.properties._product_has_bundle_gift_id) {
                    return it.variant_id == item.properties._variant_id_parent && it.properties._product_has_bundle_gift_id == item.properties._parent_product_has_bundle_gift_id 
                  } else {
                    let isAddedFromMatched = it.properties._AddedFrom == item.properties._AddedFrom || (it.properties._AddedFrom == 'product-template' && item.properties._AddedFrom == 'upsell-gift');
                    return it.variant_id == item.properties._variant_id_parent && isAddedFromMatched
                  }
                })
                if (found_parent) {
                  found_parent_variant.add(found_parent.variant_id)
                  // add check update or add cart
                  if (found_parent_bundle && found_parent_bundle.length) {
                    to_be_updated[item.key] = found_parent_bundle.length * item.properties._discount_quantity;
                  } else {
                    // 100% discount only. Let's try to figure out how many there should be
                    if (item.properties._du == 100 && (found_parent.quantity * item.properties._discount_quantity) != item.quantity) {
                      // Quantity doesn't match, let's add it to update
                      to_be_updated[item.key] = found_parent.quantity * item.properties._discount_quantity
                    }
                  }
                }
              }
            }
          }

        }
        return found_parent_variant;
      }).then(function (dataParent) {
        // type set dataParent
        // add gift free product
        let discount_id = item_added.key
        let variant_id_parent = item_added.variant_id
        let product_has_bundle_gift_id = item_added.properties._product_has_bundle_gift_id ? item_added.properties._product_has_bundle_gift_id : null

        let items = []
        if (item_added.properties._AddedFrom && item_added.properties._AddedFrom != 'product-template') {
          // preventing add gift product & related product when adding a product from another areas eg cart cross-sell.. but inside main product page
          return;
        }

        // if (!dataParent.has(item_added.variant_id)) {
          _this.$containergift.find('form').each(function () {
            let $form = $(this)
            var form_data = $form.serializeArray();

            var form_data_parent_product = $('.Product__InfoWrapper form').serializeArray();

            var quantity = form_data_parent_product.find(function (o) { return o.name == 'quantity' });
            quantity = quantity ? quantity.value : 1;
            var id = form_data.find(function (o) { return o.name == 'id' });
            let quantity_of_gift_free = form_data.find(function (o) { return o.name == 'quantity' });
            quantity_of_gift_free = quantity_of_gift_free ? quantity_of_gift_free.value : 1;
            quantity = quantity_of_gift_free * quantity

            id = id.value;
            // Let's find the line properties from the form and create an object so we retain native properties
            let native_properties = form_data.filter(function (o) { return o.name.indexOf('properties') > -1 })
            native_properties = native_properties.reduce(function (acc, o) {
              var regex = /(?:^(properties\[))(.*?)(?:\])/;
              var name = regex.exec(o.name)[2]; // Use just the value between 'properties[' and ']'
              acc[name] = o.value;
              return acc;
            }, {})

            let item = { id: id, quantity: parseInt(quantity), properties: native_properties };
            item.properties._discount_parent = '1';
            if (item_added.properties._bundle_id) {
              item.properties._discount_parent = discount_id;
            }
            item.properties._variant_id_parent = variant_id_parent;
            item.properties._discount_quantity = quantity_of_gift_free;
            item.properties._type_free_product = 'free gift';
            if (product_has_bundle_gift_id) {
              item.properties._parent_product_has_bundle_gift_id = product_has_bundle_gift_id
            }

            // Add additional bundles to cart
            item = _this.addBundleData(item, item.id);

            items.push(item);
          });
          _this.$container.find('form').each(function () {
            let $form = $(this)
            if ($form.find('input[name="id"]').is(':checked') && $form.find('input[name="id"]').is(':visible')) {

              let form_data = $form.serializeArray();
              let quantity = form_data.find(function (o) { return o.name == 'quantity' });
              quantity = quantity ? quantity.value : 1;
              let id = form_data.find(function (o) { return o.name == 'id' });
              id = id.value;

              // Let's find the line properties from the form and create an object so we retain native properties
              let native_properties = form_data.filter(function (o) { return o.name.indexOf('properties') > -1 })
              native_properties = native_properties.reduce(function (acc, o) {
                let regex = /(?:^(properties\[))(.*?)(?:\])/;
                let name = regex.exec(o.name)[2]; // Use just the value between 'properties[' and ']'
                acc[name] = o.value;
                return acc;
              }, {})

              let item = { id: id, quantity: parseInt(quantity), properties: native_properties };
              item.properties._discount_parent = discount_id;
              item.properties._variant_id_parent = variant_id_parent
              item.properties._discount_quantity = 1


              // Add additional bundles to cart
              item = _this.addBundleData(item, item.id);

              items.push(item)
              // remove null from additional_items
              // additional_items = additional_items.filter(function (el) {
              //   return el != null;
              // });
              // if (additional_items.length) {
                // items = items.concat(additional_items); // already use new cart transform for bundle
              // }
              // console.log(items)
            }
          })
          //Combine duplicates into one line
          let combined_items = items.reduce(function (acc, item) {
            let index = acc.findIndex(function (i) { return i.id === item.id && i.properties == item.properties })
            if (index > -1) {
              acc[index].quantity += 1
              acc[index].properties._discount_quantity += 1
            } else {
              item.quantity = item.quantity
              acc.push(item)
            }
            return acc
          }, [])
          if (combined_items.length > 0) {
            fetch(window.routes.cartAddUrl + '.js', {
              body: JSON.stringify({ items: combined_items }),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
              }
            }).then(function (cart) {
              return cart.json();
            }).then(function (data) {
              setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200)
            });
          }
        // }
      });
    }

  },

  bundleBackinstockDisplay: function(bundleData, container) {
    var _this = this;
    var stockStatusArr = [];
    var finalPreorderText = '';
    var finalPreorderDate = '';
    var isSoldOut = false;
    var isAllSoldOutHasAvailPreorderDate = true;

    // If all childs are is_prepacked, follow parent stock
    var isAllChildsPrepacked = true;
    bundleData.forEach(function(b) {
      if (b.is_prepacked == false) {
        isAllChildsPrepacked = false;
      }
    });
    if (!isAllChildsPrepacked) {
      bundleData.forEach(function(b) {
        //Select first variant as default
        var bundleVariant = b.variants[0]
        var bundleVariantSelect = $('[data-bundle-product-id="' + b.product_id + '"] :first select[data-bundle-variant] :selected')
        if (bundleVariantSelect.length) {
          bundleVariant = b.variants.find(function(v){ return v.id == bundleVariantSelect.val() }) || bundleVariant
        }

        if (finalPreorderText == '') {
          finalPreorderText = bundleVariant.stock_backinstock_text;
          finalPreorderDate = bundleVariant.stock_backinstock_date_ymd;
        } else {
          let finalPreorderDateTime = new Date(finalPreorderDate);
          let bundlePreOrderDate = new Date(bundleVariant.stock_backinstock_date_ymd);
          if (bundlePreOrderDate.getTime() > finalPreorderDateTime.getTime()) {
            finalPreorderText = bundleVariant.stock_backinstock_text;
            finalPreorderDate = bundleVariant.stock_backinstock_date_ymd;
          }
        }
        if (bundleVariant.stock_text_type == 'soldout') {
          isSoldOut = true;
          if (bundleVariant.stock_backinstock_text == '') {
            isAllSoldOutHasAvailPreorderDate = false;
          }
        } else {
          stockStatusArr.push(bundleVariant.stock_text_type)
        }
      })
    }

    let stockStatusTextArr = container.querySelectorAll('[stock-status-text]');
    if (isSoldOut) {
      container.classList.add('soldout');
      // update soldout text and button
      if (stockStatusArr.indexOf('preorder_with_passed_date') >= 0 || stockStatusArr.indexOf('preorder_with_unknown_date') >= 0 || !isAllSoldOutHasAvailPreorderDate) {
        _this._updateStockText(stockStatusTextArr, 'soldout', '');
      } else {
        _this._updateStockText(stockStatusTextArr, 'soldout', finalPreorderText);
      }
    } else {
      if (stockStatusArr.indexOf('preorder_with_passed_date') >= 0 || stockStatusArr.indexOf('preorder_with_unknown_date') >= 0) {
        // update preorder unknown date or passed date text and button, same function
        _this._updateStockText(stockStatusTextArr, 'preorder_with_passed_date', '');
      } else if (stockStatusArr.indexOf('preorder_with_available_date') >= 0) {
        // update preorder text and button
        _this._updateStockText(stockStatusTextArr, 'preorder_with_available_date', finalPreorderText);
      } else if (stockStatusArr.indexOf('preorder_remote_stock') >= 0) {
        // update remote text and button
        _this._updateStockText(stockStatusTextArr, 'preorder_remote_stock', '');
      } else {
        // update instock text and button
        _this._updateStockText(stockStatusTextArr, 'instock', '');
      }
    }
  },

  _updateStockText: function(stockStatusTextArr, type, customText) {
    // We show the correct stock message based on stock
    stockStatusTextArr.forEach((stockStatus) => {
      if (stockStatus.getAttribute('data-stock-type') == type) {
        stockStatus.classList.remove('hidden');
        if (customText != '') {
          if (type == 'preorder_with_available_date' || type == 'soldout') {
            stockStatus.querySelector('span').innerText = customText;
          }
        }
      } else {
        stockStatus.classList.add('hidden');
      }
    });
  },

  sortProducts: function (sources) {
    var items = []

    for (var i = 0; i < sources.length; i++) {
      var source = sources[i]

      for (var ii = 0; ii < source.products.length; ii++) {
        var product = source.products[ii]
        if (!product.id) {
          continue
        }
        for (var iii = 0; iii < product.variants.length; iii++) {
          var variant = source.products[ii].variants[iii]
          var discounted_price = variant.price;
          if (source.discount_percent > 0) {
            // Calculate the exact discounted price
            let rawDiscountedPrice = variant.price * (1 - (source.discount_percent / 100));
            
            if (window.theme.roundedDiscount) {
              // Round down to whole number if roundedDiscount is true
              discounted_price = Math.floor(rawDiscountedPrice);
            } else {
              discounted_price = roundDiscount(rawDiscountedPrice);
            }
          }
          
          var price = parseFloat(variant.price)
          var discount_percentage = ((price - discounted_price) / price) * 100 //Calcuate percentage based on the actual savings and round down
          var discount_percentage_rounded = Math.floor(discount_percentage) //Calcuate percentage based on the actual savings and round down
          
          items.push({
            variant_id: variant.id,
            variant_available: variant.available,
            product_id: product.id,
            quantity: product.quantity || 1,
            source: source,
            price,
            discounted_price: discounted_price.toFixed(2),
            discount_percentage,
            discount_percentage_rounded,
            inventory_management: variant.inventory_management,
            inventory_policy: variant.inventory_policy,
            inventory_quantity: variant.inventory_quantity
          })
        }
      }
    }

    items = items.filter((item, pos) => items.findIndex(i => i.variant_id == item.variant_id) == pos)

    return items.sort(function (a, b) { return a.discounted_price - b.discounted_price })
  },

  prerenderProducts: function (type = 'default') {

    var queryString = this.getSearchQueryString(this.products)
    if (type == 'gift') {
      queryString = this.getSearchQueryString(this.giftProducts)
      $.get(window.routes.searchUrl + '?view=product-upsell-gift-product&type=product&q=' + queryString, function (response) {
        this.shopify_gift_product_html = response
        this.renderProducts(false)
      }.bind(this), 'json')
    } else {
      $.get(window.routes.searchUrl + '?view=product-upsell&type=product&q=' + queryString, function (response) {
        // console.log('response', response)
        this.shopify_products_html = response
        this.renderProducts(true)
        document.querySelectorAll('.discount-upsell__list [data-discount]').forEach((el) => {
          var discount = el.dataset.discount
          if (discount <= 0) {
            el.querySelector('.Price.Price--compareAt').style.display = 'none'
            el.querySelector('.ProductMeta__Save').style.display = 'none'
          }
        })
        this.loading(false)
      }.bind(this), 'json')
    }

  },
  renderProducts: function (addToDiscountCalculation) {
    let self = this;
    // Use original rebuy data to get sort order
    if (typeof this.products == 'undefined') {
      this.products = [];
    }
    var products_html = this.products.map(function (p) {
      if (!this.shopify_products_html) {
        return ''
      }
      var html = this.shopify_products_html[p.variant_id];
      if (!html) {
        return ''
      }
      // console.log('p', p)
      // var discount_price = p.source.discount_percent == 100 ? theme.Currency.formatMoney(0, theme.moneyFormat) : theme.Currency.formatMoney(Math.floor(parseInt(p.discounted_price)) * 100, theme.moneyFormat);
      var discount_price = theme.Currency.formatMoney(Math.floor(parseInt(p.discounted_price)) * 100, theme.moneyFormat)
      if (p.source.discount_percent == 0) {
        discount_price = p.price
      } else if (p.source.discount_percent == 100) {
        discount_price = theme.Currency.formatMoney(0, theme.moneyFormat)
      } else if (window.theme.roundedDiscount != true) {
        discount_price = theme.Currency.formatMoney(p.discounted_price, theme.moneyFormat)
      }

      html = html.replace(/{{ price }}/g, discount_price);

      if (addToDiscountCalculation) {
        this.total_discount += parseFloat(p.discounted_price)
      }

      let pPriceToCalcDiscount = p.price;
      let discountPercentRounded = p.discount_percentage_rounded;

      const hash_input = "gid://shopify/ProductVariant/" + p.variant_id + "," + p.discount_percentage_rounded;
      
      // check if html has data-variant-price-no-discount
      if (html.indexOf('data-variant-price-no-discount') > -1) {
        // priceNoDiscount = value of data-variant-price-no-discount
        let priceNoDiscount = html.match(/data-variant-price-no-discount="([^"]*)"/)[1];
        // calculate new discount percent
        if (priceNoDiscount) {
          discountPercentRounded = Math.floor(((parseFloat(priceNoDiscount) - (parseFloat(p.discounted_price) * 100.0)) / (parseFloat(priceNoDiscount)) * 100.0));
          pPriceToCalcDiscount = parseFloat(priceNoDiscount / 100.0);
        }
      }
      if (addToDiscountCalculation) {
        this.total_price += pPriceToCalcDiscount
      }

      html = html.replace(/{{ discount_display }}/g, discountPercentRounded)
      html = html.replace(/{{ discount }}/g, p.discount_percentage_rounded)
      html = html.replace(/{{ discount_h }}/g, sha256(hash_input).hex())
      return html
    }.bind(this));

    // console.log('total_discount', this.total_discount)  
    // console.log('total_price', this.total_price)

    var discount_percentage = Math.floor(((parseFloat(this.total_price) - parseFloat(this.total_discount)) / parseFloat(this.total_price)) * 100);
    // console.log('discount_percentage', discount_percentage)
    if (this.showSaveUpToLabel && isNaN(discount_percentage) == false) {
      document.querySelectorAll('.discount-upsell .ProductMeta__Save').forEach((el) => {
        if (discount_percentage > 0) {
          el.style.display = 'block'
          if (el.querySelector("strong")) {
            el.querySelector("strong").innerHTML = Math.floor(discount_percentage) + "%";
          }
          if (el.querySelector("span") && el.querySelector("span").childNodes[0]) {
            el.querySelector("span").childNodes[0].nodeValue = window.theme.string.saveUpTo + ' '
            el.querySelector("span").style.display = 'inline-block'
          }
        } else {
          el.style.display = 'none'
        }
      })

      //ProductMeta__Save saveUpTo
      document.querySelectorAll('.saveUpTo').forEach((el) => {
        if (discount_percentage > 0) {
          el.innerHTML = window.theme.string.saveUpTo + ' <strong>' + Math.floor(discount_percentage) + '%</strong>';
          el.style.display = 'inline-block'
        } else {
          el.style.display = 'none'
        }
      })
    } else {
      document.querySelectorAll('.discount-upsell .ProductMeta__Save').forEach((el) => {
        el.style.display = 'none'
      })
    }
    document.querySelectorAll('.saveUpTo.alwaysVisible').forEach((el) => {
      if (discount_percentage > 0) {
        el.innerHTML = window.theme.string.saveUpTo + ' <strong>' + Math.floor(discount_percentage) + '%</strong>';
        el.style.display = 'inline-block'
      } else {
        el.style.display = 'none'
      }

    })
    this.showMoreButtons.forEach((button) => {
      if (this.products.length > 4) {
        button.classList.add("show-more");
        button.style.display = "";
      } else {
        button.style.display = "none";
      }
    })

    if (products_html.length > 0) {
      var has_li_html = false;
      this.$container.each(function () {
        $subContainer = $(this)
        $subContainer.find('ul').html(products_html.join(''))
        if ($subContainer.find('ul li').length > 0) {
          has_li_html = true
        }
        $subContainer.find('ul li').each(function (index) {
          var $this = $(this)
          if (index > 3) {
            $this.hide();
          }
          var discount_percent = $this.data('discount')
          if (discount_percent == 100) {
            $this.find('input[name="id"]').prop('checked', true)
            $this.find('[data-tiered-option-price]').remove()
          } else {
            //Manipulate tiered pricing options
            $this.find('[data-tiered-option-price]').each(function (idx, el) {
              var $tier_option = $(this)
              var tiered_price = $tier_option.data('tiered-option-price')
              var final_price = tiered_price * (1 - (discount_percent / 100));
              if (idx == 0) {
                final_price = Math.floor((final_price / 100)) * 100
              }
              var price_formatted = theme.Currency.formatMoney(Math.floor(parseInt(final_price)), theme.moneyFormat)
              $tier_option.html(idx + 1 + ' - ' + price_formatted)
            })
          }

          // handle bundle product in upsell
          if (this.querySelector('[data-bundle-json]')) {
            let pBundleData = JSON.parse(this.querySelector('[data-bundle-json]')?.innerHTML);
            let parentVariantId = this.querySelector('[data-bundle-json]')?.getAttribute('data-parent-variant-id');
            if (typeof window.upsellBundleData == 'undefined') {
              window.upsellBundleData = {};
            }
            window.upsellBundleData[parentVariantId] = pBundleData;
            // console.log(window.upsellBundleData);
            self.bundleBackinstockDisplay(pBundleData, this);
          }
          
        })
      })


      document.querySelectorAll(".discount-upsell__list li").forEach((input) => {
        if (input.querySelector(".Form__CheckboxWrapper  input").checked) {
          input.classList.add('checked');
        }
        input.querySelector(".Form__CheckboxWrapper  input").addEventListener("click", function (e) {
          e.preventDefault();
          input.querySelector(".Form__CheckboxWrapper  input").checked = !input.querySelector(".Form__CheckboxWrapper  input").checked;
          if (input.querySelector(".Form__CheckboxWrapper  input").checked) {
            input.classList.remove('checked');
          } else {
            input.classList.add('checked');
          }
        })
        input.addEventListener("click", function (e) {
          let clickedOnQty = false;
          if (input.querySelector(".QuantitySelector")) {
            if (input.querySelector(".QuantitySelector").contains(e.target)) {
              clickedOnQty = true;
            }
          }
          if (!clickedOnQty) {
            input.querySelector(".Form__CheckboxWrapper  input").checked = !input.querySelector(".Form__CheckboxWrapper  input").checked;
            if (input.classList.contains('checked')) {
              input.classList.remove('checked');
            } else {
              input.classList.add('checked');
            }
          } else {
            let inputQtyVal = parseInt(input.querySelector('.QuantitySelector input').value);
            if (inputQtyVal > 0) {
              input.querySelector(".Form__CheckboxWrapper input").checked = true;
              input.classList.add('checked');
            } else {
              input.querySelector(".Form__CheckboxWrapper input").checked = false;
              input.classList.remove('checked');
            }
          }
        })
      });
      if (has_li_html == true) {
        this.$container.show();
      } else {
        document.querySelectorAll('.saveUpTo').forEach((el) => {
          el.style.display = 'none'
        })
      }
    }
    if (typeof this.giftProducts == 'undefined') {
      this.giftProducts = [];
    }

    // re-assign this val to avoid duplicate amount
    this.totalGiftDiscountedPrice = 0;

    var gift_product_html = this.giftProducts.map(function (p) {
      if (!this.shopify_gift_product_html) {
        return ''
      }

      var html = this.shopify_gift_product_html[p.variant_id];
      if (!html) {
        return ''
      }

      var discount_price = p.source.discount_percent == 100
        ? theme.Currency.formatMoney(0, theme.moneyFormat)
        : theme.Currency.formatMoney(Math.floor(parseInt(p.discounted_price)) * 100, theme.moneyFormat)
      html = html.replace(/{{ price }}/g, discount_price);

      const hash_input = "gid://shopify/ProductVariant/" + p.variant_id + "," + p.discount_percentage_rounded;
      const hash = sha256(hash_input).hex();;
      
      //this.total_discount += p.discounted_price
      //this.total_price += p.price
      html = html.replace(/{{ discount }}/g, p.discount_percentage_rounded);
      html = html.replace(/{{ discount_h }}/g, hash);

      if (p.source.discount_percent == 100) {
        this.totalGiftDiscountedPrice += p.price * p.quantity;
      }

      if (p.quantity && p.quantity != 'undefined' && p.quantity != undefined) {
        html = html.replace(/{{ quantity }}/g, p.quantity)
        html = html.replace(/{{ quantity_line }}/g, p.quantity)
      } else {
        html = html.replace(/{{ quantity }}/g, 1)
        html = html.replace(/{{ quantity_line }}/g, 1)
      }
      return html
    }.bind(this));
    let _this = this;
    if (gift_product_html.length > 0) {
      this.$containergift.find('.rebuy-gift-product').html(gift_product_html.join(''));
      // handle bundle product in gift
      let giftContainsBundle = false;
      this.$containergift.find('ul li').each(function (index) {
        if (this.querySelector('[data-bundle-json]')) {
          let pBundleData = JSON.parse(this.querySelector('[data-bundle-json]')?.innerHTML);
          let parentVariantId = this.querySelector('[data-bundle-json]')?.getAttribute('data-parent-variant-id');
          if (typeof window.upsellBundleData == 'undefined') {
            window.upsellBundleData = {};
          }
          window.upsellBundleData[parentVariantId] = pBundleData;
          // console.log(window.upsellBundleData);
          self.bundleBackinstockDisplay(pBundleData, this);
          giftContainsBundle = true;
        }
      });

      this.$containergift.show();
      if (giftContainsBundle) {
        // add a hidden property field to parent product, so we know it has bundle inside of gift products, 
        // the purpose is to make it not grouping by qty in cart each time adding to cart
        if (document.querySelector('.Product__Info form.ProductForm')) {
          if (!document.querySelector('.Product__Info form.ProductForm input[name="_product_has_bundle_gift"]')) {
            // check if form has this hidden input already, if not, add it
            let form = document.querySelector('.Product__Info form.ProductForm');
            let hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = '_product_has_bundle_gift';
            hiddenInput.value = 'true';
            form.appendChild(hiddenInput);
          }
        }
      }

      if (this.totalGiftDiscountedPrice > 0) {
        if (document.querySelector('.Product__Info .ProductMeta .ProductMeta__Price[data-compare-at-price]')) {
          // on load, the first variant have compare at price. then we calc base on compare at price
          let pNode = document.querySelector('.Product__Info .ProductMeta .ProductMeta__Price[data-compare-at-price]');
          let originalCompareAtPrice = parseFloat(pNode.getAttribute('data-compare-at-price')) / 100;
          let originalPrice = parseFloat(pNode.getAttribute('data-price')) / 100;
          let newCompareAtPrice = this.totalGiftDiscountedPrice + originalCompareAtPrice;
          pNode.textContent = theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat);
          let newSalePercent = Math.floor((newCompareAtPrice - originalPrice) / newCompareAtPrice * 100);
          document.querySelector('.Product__Info .ProductMeta .custom-pricetag-save span').textContent = newSalePercent;
          // also update sticky price
          if (document.querySelector('.sticky-product-infor .price-compare-wrapper .price-compare')) {
            let pNodeSticky = document.querySelector('.sticky-product-infor .price-compare-wrapper .price-compare');
            pNodeSticky.textContent = theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat);
          }
          if (document.querySelector('.sticky-product-infor .price-compare-wrapper .custom-pricetag-save')) {
            let pNodeSticky = document.querySelector('.sticky-product-infor .price-compare-wrapper .custom-pricetag-save span');
            pNodeSticky.textContent = newSalePercent;
          }
        } else {
          // on load, the first variant doesn't have compare at price. then we calc base on price
          if (document.querySelector('.Product__Info .ProductMeta .ProductMeta__Price[data-price]')) {
            let originalPrice = parseFloat(document.querySelector('.Product__Info .ProductMeta .ProductMeta__Price[data-price]').getAttribute('data-price')) / 100;
            let originalCompareAtPrice = originalPrice;
            let newCompareAtPrice = this.totalGiftDiscountedPrice + originalCompareAtPrice;
            let newSalePercent = Math.floor((newCompareAtPrice - originalPrice) / newCompareAtPrice * 100);

            if (document.querySelector('.Product__Info .ProductMeta .pricetag')) {
              if (document.querySelector('.Product__Info .ProductMeta .custom-price-wrapper .Price--compareAt')) {
                document.querySelector('.Product__Info .ProductMeta .custom-price-wrapper .Price--compareAt').textContent = theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat);
              }
              if (document.querySelector('.Product__Info .ProductMeta .custom-pricetag-save span')) {
                document.querySelector('.Product__Info .ProductMeta .custom-pricetag-save span').textContent = newSalePercent;
              }
              // also update sticky price
              if (document.querySelector('.sticky-product-infor .price-compare-wrapper .price-compare')) {
                let pNodeSticky = document.querySelector('.sticky-product-infor .price-compare-wrapper .price-compare');
                pNodeSticky.textContent = theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat);
              }
              if (document.querySelector('.sticky-product-infor .price-compare-wrapper .custom-pricetag-save')) {
                let pNodeSticky = document.querySelector('.sticky-product-infor .price-compare-wrapper .custom-pricetag-save span');
                pNodeSticky.textContent = newSalePercent;
              }
            } else {
              let newPriceHtml = '<div class="pricetag">';
              newPriceHtml += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + theme.Currency.formatMoney(originalPrice * 100, theme.moneyFormat) + '</span>';
              newPriceHtml += '<div class="custom-pricetag-wrapper"><div class="custom-price-wrapper"><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4 custom-pricetag" data-money-convertible>' + theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat) + '</span><span class="custom-pricetag-save">'+ window.languages.productSavePercent+' <span>'+newSalePercent.toFixed()+'</span>%</span></div></div>';
              newPriceHtml += '</div>';
              if (document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList > .ProductMeta__Price')) {
                document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList > .ProductMeta__Price').remove();
                document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList').innerHTML = newPriceHtml + document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList').innerHTML;
              }
              // also update sticky price
              if (document.querySelector('.sticky-product-infor .price-compare-wrapper .price-compare') && document.querySelector('.sticky-product-infor .price-compare-wrapper .custom-pricetag-save')) {
                let pNodeSticky = document.querySelector('.sticky-product-infor .price-compare-wrapper .price-compare');
                pNodeSticky.textContent = theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat);
              }
              if (document.querySelector('.sticky-product-infor .price-compare-wrapper .custom-pricetag-save')) {
                let pNodeSticky = document.querySelector('.sticky-product-infor .price-compare-wrapper .custom-pricetag-save span');
                pNodeSticky.textContent = newSalePercent;
              }
            }
          }
        }
      }

      _this.resizeGiftProduct();
    }
  },
  getSearchQueryString: function (items) {
    if (!items) {
      return ''
    }
    return items.map(function (item) {
      return 'id:' + item.product_id;
    }).join(' OR ');
  },
  addBundleData: function (item, productId) {
    var additional_items = [];
    if (window.upsellBundleData && window.upsellBundleData[productId]) {
      var bundle_id = Math.random().toString(36).substring(2, 15);
      var bundle_titles = [];
      var bundle_variant_ids = [];
      var bundle_stock_properties = [];
      var additional_properties = {};
      var haveSoldout = false;
      var havePreorder = false;
      let finalPreorderDate = '';
      let isAllChildsPrepacked = true;
      additional_items = window.upsellBundleData[productId].map(function(b){
        if (!b.is_prepacked) {
          isAllChildsPrepacked = false;
        }
        //Select first variant as default
        var bundleVariant = b.variants[0]
        var bundleVariantSelect = $('[data-bundle-product-id="' + b.product_id + '"] :first select[data-bundle-variant] :selected')
        if (bundleVariantSelect.length) {
          bundleVariant = b.variants.find(function(v){ return v.id == bundleVariantSelect.val() }) || bundleVariant
        }
        var bundle = { id: bundleVariant.id, quantity: b.quantity * item.quantity, properties: {} };
        bundle.properties._p_bundle_id = bundle_id;

        if (item.properties._AddedFrom) {
          bundle.properties._AddedFrom = item.properties._AddedFrom;
        }

        // new function check by new condition but follow old function logic
        if (bundleVariant.stock_text_type == 'soldout') {
          haveSoldout = true;
          if (bundleVariant.stock_backinstock_date != '01-01-70' && bundleVariant.stock_backinstock_date != '') {
            additional_properties._SoldOut = bundleVariant.stock_backinstock_date;
            bundle.properties._SoldOut = bundleVariant.stock_backinstock_date;
            bundle_stock_properties.push(`${bundleVariant.id} x _SoldOut x ${bundleVariant.stock_backinstock_date}`);
          } else {
            additional_properties._SoldOut = window.languages.productFormSoldOut;
            bundle.properties._SoldOut = window.languages.productFormSoldOut;
            bundle_stock_properties.push(`${bundleVariant.id} x _SoldOut x ${window.languages.productFormSoldOut}`);
          }
          additional_properties[window.languages.preorderLabel] = window.languages.preorderInfoTextNoDate; // for cart transform
        } else {
          if (bundleVariant.stock_text_type == 'preorder_with_passed_date' || bundleVariant.stock_text_type == 'preorder_with_unknown_date') {

            if (bundleVariant.stock_backinstock_date != '01-01-70' && bundleVariant.stock_backinstock_date != '') {
              bundle.properties._SoldOut = bundleVariant.stock_backinstock_date;
              bundle_stock_properties.push(`${bundleVariant.id} x _SoldOut x ${bundleVariant.stock_backinstock_date}`);
              additional_properties._SoldOut = bundleVariant.stock_backinstock_date;
            } else {
              bundle.properties._SoldOut = window.languages.productFormSoldOut;
              bundle_stock_properties.push(`${bundleVariant.id} x _SoldOut x ${window.languages.productFormSoldOut}`);
              additional_properties._SoldOut = window.languages.productFormSoldOut;
            }
            haveSoldout = true;
            additional_properties[window.languages.preorderLabel] = window.languages.preorderInfoTextNoDate; // for cart transform
          } else if (bundleVariant.stock_text_type == 'preorder_remote_stock') {
            additional_properties._RemoteStock = window.languages.remoteStock;
            bundle.properties._RemoteStock = window.languages.remoteStock;
            bundle_stock_properties.push(`${bundleVariant.id} x _RemoteStock x ${window.languages.remoteStock}`);
          } else {
            if (bundleVariant.stock_text_type == 'preorder_with_available_date') {
              if (additional_properties._PreOrder == null) {
                additional_properties._PreOrder = bundleVariant.stock_backinstock_date;
                additional_properties[window.languages.preorderLabel] = window.languages.preorderInfoTextDate.replace('{{ date }}', bundleVariant.stock_backinstock_date); // for cart transform
                finalPreorderDate = bundleVariant.stock_backinstock_date_ymd;
              } else {
                let finalPreorderDateTime = new Date(finalPreorderDate);
                let bundlePreOrderDateTime = new Date(bundleVariant.stock_backinstock_date_ymd);
                if (bundlePreOrderDateTime.getTime() > finalPreorderDateTime.getTime()) {
                  additional_properties._PreOrder = bundleVariant.stock_backinstock_date;
                  additional_properties[window.languages.preorderLabel] = window.languages.preorderInfoTextDate.replace('{{ date }}', bundleVariant.stock_backinstock_date); // for cart transform
                  finalPreorderDate = bundleVariant.stock_backinstock_date_ymd;
                }
              }

              bundle.properties._PreOrder = bundleVariant.stock_backinstock_date;
              bundle_stock_properties.push(`${bundleVariant.id} x _PreOrder x ${bundleVariant.stock_backinstock_date}`);
              havePreorder = true;
            }
          }
        }

        var bundleTitle = b.title
        if (bundleVariantSelect.length || b.variants.length > 1) {
          bundleTitle += ' (' + bundleVariant.title + ')'
        }
        bundle_titles.push(bundleTitle);
        if (!b.is_prepacked) {
          bundle_variant_ids.push(`${b.quantity} x ${bundleVariant.id}`);
        }
        
        if (b.is_prepacked) {
          item.properties._bundle_prepacked = true;
          return null;
        }
        return bundle;
      });
      if (isAllChildsPrepacked) {
        additional_properties = {};
      } else {
        if (haveSoldout) {
          delete additional_properties._PreOrder;
          delete additional_properties._RemoteStock;
        } else {
          if (havePreorder) {
            delete additional_properties._RemoteStock;
          }
        }
      }
      item.properties = Object.assign(item.properties, additional_properties)
      item.properties._bundle_id = bundle_id;
      item.properties._bundle_titles = bundle_titles.join(',');
      item.properties._bundle_variant_ids = bundle_variant_ids.join(',');
      item.properties._bundle_stock_properties = bundle_stock_properties.join(',');
      // property to show on checkout
      if (item.properties._bundle_prepacked) {
        item.properties[window.theme.prepackedBundlePropertyText] = bundle_titles.join(', ');
      }
    }
    return item;
  }
}


if (window.theme.cartEnableTerms) {
  Dtails.cartEnableTerms();
}

if (window.theme.template.includes('product') || window.theme.template.includes('collection')) {
  Dtails.CrossSellModal.init()
}
if (window.theme.template.includes('product')) {
  Dtails.DiscountUpsell.init()
}
if (window.theme.template.includes('collection')) {
  Dtails.DiscountUpsell.collectionInit()
}
Dtails.DiscountUpsell.initGlobalEventHandlers()

document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant;
  if (typeof variant != 'undefined') {
    if ($('[data-specs-variant-id="' + variant.id + '"]').length) {
      $('[data-specs-variant-id]').hide()
      $('[data-specs-variant-id="' + variant.id + '"]').show()
    }

    // update compare at price that include gift discount  
    if (Dtails.DiscountUpsell.totalGiftDiscountedPrice > 0) {
      // to make sure it run after custom pricetag generated
      setTimeout(function() {
        let originalPrice = parseFloat(variant.price) / 100;
        let originalCompareAtPrice = originalPrice;
        if (variant.compare_at_price != null) {
          originalCompareAtPrice = parseFloat(variant.compare_at_price) / 100;
        }
        let newCompareAtPrice = Dtails.DiscountUpsell.totalGiftDiscountedPrice + originalCompareAtPrice;
        let newSalePercent = Math.floor((newCompareAtPrice - originalPrice) / newCompareAtPrice * 100);

        if (document.querySelector('.Product__Info .ProductMeta .pricetag')) {
          if (document.querySelector('.Product__Info .ProductMeta .custom-price-wrapper .Price--compareAt')) {
            document.querySelector('.Product__Info .ProductMeta .custom-price-wrapper .Price--compareAt').textContent = theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat);
          }
          if (document.querySelector('.Product__Info .ProductMeta .custom-pricetag-save span')) {
            document.querySelector('.Product__Info .ProductMeta .custom-pricetag-save span').textContent = newSalePercent;
          }
        } else {
          let newPriceHtml = '<div class="pricetag">';
          newPriceHtml += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + theme.Currency.formatMoney(variant.price, theme.moneyFormat) + '</span>';
          newPriceHtml += '<div class="custom-pricetag-wrapper"><div class="custom-price-wrapper"><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4 custom-pricetag" data-money-convertible>' + theme.Currency.formatMoney(newCompareAtPrice * 100, theme.moneyFormat) + '</span><span class="custom-pricetag-save">'+ window.languages.productSavePercent+' <span>'+newSalePercent.toFixed()+'</span>%</span></div></div>';
          newPriceHtml += '</div>';
          if (document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList > .ProductMeta__Price')) {
            document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList > .ProductMeta__Price').remove();
            document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList').innerHTML = newPriceHtml + document.querySelector('.Product__Info .ProductMeta .ProductMeta__PriceList').innerHTML;
          }
        }
      }, 30);
    }
  }
});

if (window.theme.template.includes('collection')) {
  Dtails.productCartAjax('body')
}

Dtails.AutomaticDiscount.load();

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    var topButton = document.querySelector('.ProductForm__AddToCart').offsetTop;
    if (!topButton) {
      return
    }
    window.addEventListener('scroll', () => {
      if (window.scrollY >= topButton) {
        this.show();
      } else {
        this.hide();
      }
    });
    this.querySelector('.ProductForm__Sticky_AddToCart').addEventListener('click', (e) => {
      e.preventDefault();
      if (document.querySelector('.ProductForm__AddToCart')) {
        document.querySelector('.ProductForm__AddToCart').click();
      }
      this.hide();
    })
  }

  async show() {
    this.setAttribute('open', '');
    var minHeight = this.querySelector('.ProductForm__Actions').clientHeight + 30
    if (minHeight < 80) {
      if (this.querySelector('.sticky-stock-text') && this.querySelector('.sticky-stock-text').offsetHeight > 0) {
        minHeight += 57
        this.style.minHeight = minHeight + 'px';
      } else {
        this.style.minHeight = 0 + 'px';
      }
    }
  }

  hide() {
    this.removeAttribute('open')
  }
}

customElements.define('sticky-add-cart', StickyAddCart)

// Cart cross sell
if (window.theme.cartEnableCrossSell) {
  // window.postPurchaseHost = 'https://raasdal-service.herokuapp.com';
  // below host is for local testing
  window.cartCrossSellHost = 'https://raasdal-pim.devtails.dk/';
  if (typeof Dtails === "undefined") {
    var Dtails = {};
  }

  Dtails.cartCrossSell = {
    currentToken: null,
    init: function () {

      // create token to abort old request when new request is sent
      var newToken = Math.random();
      this.currentToken = newToken;

      // fet sources then render content
      var queryString = this.getSearchQueryStringFromId(window.cartCrossSellIds);
      $.get(window.routes.searchUrl + '?view=cart-cross-sell-parent&type=product&q=' + queryString, function (response) {
        if (this.currentToken !== newToken) {
          return;  // Abort if this isn't the latest call
        }
        window.cartCrossSellConfigs = JSON.parse(response);

        let allSources = [];
        window.cartCrossSellConfigs.forEach((config) => {
          for (let key in config) {
            allSources = allSources.concat(config[key]);
          }
        });

        this.products = this.sortProducts(allSources);
        
        this.products = this.products.filter((item) => {
          return !window.cartCrossSellIds.includes(item.product_id);
        });

        if (this.products.length) {
          window.cartCrossSellProducts = this.products;
          this.renderProducts()
        } else {
          document.querySelector('.cart-cross-sell-wrapper')?.remove();
        }
      }.bind(this));
    },

    sortProducts: function (sources) {
      var items = []

      for (var i = 0; i < sources.length; i++) {
        var source = sources[i]

        for (var ii = 0; ii < source.products.length; ii++) {
          var product = source.products[ii]
          if (!product.id) {
            continue
          }
          for (var iii = 0; iii < product.variants.length; iii++) {
            var variant = source.products[ii].variants[iii]
            var discounted_price = variant.price;
            if (source.discount_percent > 0) {
              // Calculate the exact discounted price
              let rawDiscountedPrice = variant.price * (1 - (source.discount_percent / 100));
              
              if (window.theme.roundedDiscount) {
                // Round down to whole number if roundedDiscount is true
                discounted_price = Math.floor(rawDiscountedPrice);
              } else {
                discounted_price = roundDiscount(rawDiscountedPrice);
              }
            }
            var price = parseFloat(variant.price)
            var discount_percentage = ((price - discounted_price) / price) * 100 //Calcuate percentage based on the actual savings and round down
            var discount_percentage_rounded = Math.floor(discount_percentage) //Calcuate percentage based on the actual savings and round down

            items.push({
              variant_id: variant.id,
              product_id: product.id,
              quantity: product.quantity || 1,
              source: source,
              price,
              discounted_price: discounted_price.toFixed(2),
              discount_percentage,
              discount_percentage_rounded
            })
          }
        }
      }

      items = items.filter((item, pos) => items.findIndex(i => i.variant_id == item.variant_id) == pos)

      return items.sort(function (a, b) { return a.discounted_price - b.discounted_price })
    },

    renderProducts: function () {
      var queryString = this.getSearchQueryString(this.products);
      $.get(window.routes.searchUrl + '?view=cart-cross-sell&type=product&q=' + queryString, function (response) {
        document.querySelectorAll('.cart-cross-sell-wrapper').forEach((el) => {
          el.remove();
        });
        if (window.innerWidth >= 768) {
          document.querySelector('#sidebar-cart .Drawer__Header').insertAdjacentHTML('beforebegin', response);
        } else {
          document.querySelector('#sidebar-cart .Drawer__Footer').insertAdjacentHTML('beforebegin', response);
          // make .cart-cross-sell-wrapper .ProductList become carousel
          if (document.querySelector('.cart-cross-sell-wrapper .ProductList')) {
            setTimeout(function() {
              new Flickity('.cart-cross-sell-wrapper .ProductList', {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                pageDots: true,
                prevNextButtons: false
              });
            }, 1000);
            
          }

        }

        this.initDiscountPrice();

        document.querySelectorAll('.cart-cross-sell-wrapper .ProductItem').forEach((prod) => {
          let delegateElement = new domDelegate.Delegate(prod);
          delegateElement.on('variant:changed', function(e) {
            setTimeout(function() {
              this.initDiscountPrice();
            }.bind(this), 200);
          }.bind(this));
        });

        // init listeners same as product grid item
        Dtails.productCartAjax('.cart-cross-sell-wrapper');

        // init data parent for each cross sell product
        document.querySelectorAll('.cart-cross-sell-wrapper .ProductItem').forEach((prod) => {
          let id = prod.getAttribute('data-product-item-form');
          let item = this.products.find((item) => item.product_id == id);

          if (item) {
            let parentCartItem = document.querySelector(`.CartItem[data-cross-sell-product-id="${item.source.parent_product_id}"]`);
            if (parentCartItem) {
              let parentKey = parentCartItem.getAttribute('data-line-item-key');
              let parentVariantId = parentCartItem.getAttribute('data-variant-id');
              let variantId = "gid://shopify/ProductVariant/" + item.variant_id;
              const hash_input = `${variantId},${item.source.discount_percent}`;
              const hash = sha256(hash_input).hex();
              
              let form = prod.querySelector('form');
              if (form) {
                form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="properties[_discount_quantity]" value="1">`);
                form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="properties[_du]" value="${item.source.discount_percent}">`);
                form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="properties[_dh]" value="${hash}">`);
                form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="properties[_discount_parent]" value="${parentKey}">`);
                form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="properties[_variant_id_parent]" value="${parentVariantId}">`);
              }
            }
          }
        });
      }.bind(this));
    },

    // init discount price
    initDiscountPrice: function () {
      for (let p of this.products) {
        let sourceDiscount = p.source.discount_percent;
        let prod = document.querySelector(`.cart-cross-sell-wrapper .ProductItem[data-product-item-form="${p.product_id}"]`);
        if (prod) {
          let currentVariantId = prod.querySelector('[name="id"]').value;
          if (currentVariantId == p.variant_id) {
            if (sourceDiscount > 0) {
              prod.querySelector('.Price--highlight').textContent = theme.Currency.formatMoney(p.discounted_price * 100, theme.moneyFormat);
              if (p.discounted_price < p.price) {
                if (prod.querySelector('.Price--compareAt')) {
                  prod.querySelector('.Price--compareAt').textContent = theme.Currency.formatMoney(p.price * 100, theme.moneyFormat);
                  prod.querySelector('.custom-pricetag-wrapper').classList.remove('hidden');
                  prod.querySelector('.custom-pricetag-save span').textContent = p.discount_percentage_rounded;
                }
              }
            } else {
              prod.querySelector('.Price--highlight').textContent = theme.Currency.formatMoney(p.price * 100, theme.moneyFormat);
            }
          }
        }
      }
    },

    getSearchQueryStringFromId: function (ids) {
      if (!ids) {
        return ''
      }
      return ids.map(function (id) {
        return 'id:' + id;
      }).join(' OR ');
    },

    getSearchQueryString: function (items) {
      if (!items) {
        return ''
      }
      return items.map(function (item) {
        return 'id:' + item.product_id;
      }).join(' OR ');
    }
  }

  document.addEventListener('cart:rendered', function () {
    if (window.isNotFirstCartLoad) {
      updateNewestCartCrossSellIds();
      Dtails.cartCrossSell.init();
    }
  });
  document.addEventListener('cart:open', function () {
    if (!window.isNotFirstCartLoad) {
      updateNewestCartCrossSellIds();
      Dtails.cartCrossSell.init();
      window.isNotFirstCartLoad = true;
    }
  });

  // update newest cart ids and cart cross sell ids
  function updateNewestCartCrossSellIds() {
    window.cartCrossSellIds = [];
    document.querySelectorAll('.CartItem').forEach((item) => {
      if (item.getAttribute('data-cross-sell-product-id')) {
        window.cartCrossSellIds.push(item.getAttribute('data-cross-sell-product-id'));
      }
    });
  }
}
